"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _uuid = require("uuid");
var _useLazyRef = _interopRequireDefault(require("../useLazyRef"));
var _useAsyncEffect = _interopRequireDefault(require("../useAsyncEffect"));
var _DataFetch = require("./contexts/DataFetch");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useDataFetch = function useDataFetch(effect, dependencies, id) {
  var fetchId = (0, _useLazyRef.default)(function () {
    return "".concat(id ? "".concat(id, "__") : '').concat((0, _uuid.v4)());
  });
  var dataFetchContext = (0, _react.useContext)(_DataFetch.DataFetchContext);
  // Server-Side fetching
  if (dataFetchContext && !dataFetchContext.allResolved) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var cancel_1 = function cancel_1(value) {};
    var effectPromise = function effectPromise(options) {
      return new Promise(function (resolve) {
        cancel_1 = resolve;
        var resolved = false;
        effect(options).then(function (value) {
          resolved = true;
          resolve(value);
          return value;
        }).finally(function () {
          if (!resolved) {
            resolve(undefined);
          }
        });
      });
    };
    dataFetchContext.requests.push({
      id: fetchId.current,
      promise: effectPromise,
      cancel: cancel_1,
      data: undefined
    });
  }
  // Client-Side fetching
  (0, _useAsyncEffect.default)(effect, dependencies);
};
var _default = useDataFetch;
exports.default = _default;